export default "__VITE_ASSET__9NdDnxYV__"